import { memo, useState } from 'react'

import cross from 'assets/svg/cross.svg'

import { Button } from '@/shared/ui'
import { Icon } from '@/shared/ui/icon'

import { BasketRemoveModal } from '../basket-remove-modal/basket-remove-modal'
import { ConfirmPopup } from '../confirm-popup/confirm-popup'

import styles from './basket-item-table.module.scss'

type RemoveButtonProps = {
	onRemove: () => void
	isMobile?: boolean
}

/**
 * Компонент кнопки удаления товара из корзины
 * Desktop версия - с Popover
 * Mobile версия - с Modal
 */
export const RemoveButton = memo(({ onRemove, isMobile = false }: RemoveButtonProps) => {
	const [isVisibleModal, setIsVisibleModal] = useState<boolean>(false)

	if (isMobile) {
		return (
			<>
				<div className={`${styles.removeCell} ${styles.removeCell_mobile}`}>
					<Button aria-label="Удалить товар из корзины" theme="link" onClick={() => setIsVisibleModal(true)}>
						<Icon icon={cross} aria-hidden={true} fill="#c0c0c0" />
					</Button>
				</div>

				<BasketRemoveModal
					open={isVisibleModal}
					onCancel={() => setIsVisibleModal(false)}
					onOk={() => {
						onRemove()
						setIsVisibleModal(false)
					}}
				/>
			</>
		)
	}

	return (
		<div className={styles.removeCell}>
			<ConfirmPopup
				title="Удаление товара"
				description="Вы точно хотите удалить товар из корзины? Отменить действие будет невозможно"
				okText="Удалить"
				onConfirm={onRemove}>
				<Button aria-label="Удалить товар из корзины" theme="link">
					<Icon icon={cross} aria-hidden={true} />
				</Button>
			</ConfirmPopup>
		</div>
	)
})
